module.exports = __webpack_public_path__ + "img/facebook_white.ec3c6f23.svg";